/**
 * Resuelve la URL del panel de administración (admin-frontend) con prioridad:
 *   1. process.env.REACT_APP_ADMIN_URL (si fue definida en build time)
 *   2. Detección por hostname
 *      - dev.gestdoc.cl   → https://devadmin.gestdoc.cl
 *      - flow.gestdoc.cl  → https://admin.gestdoc.cl
 *      - otro *.gestdoc.cl → admin.gestdoc.cl
 *   3. Desarrollo local → http://localhost:4000
 *
 * Por qué existe: REACT_APP_ADMIN_URL nunca se definió en los .env, así que
 * el enlace "Mis documentos" del flujo quedaba apuntando a localhost:4000 en
 * dev y en producción, y Profile.js abría siempre el admin de producción
 * aunque el usuario estuviera en dev.
 *
 * Uso:
 *   import ADMIN_URL from '../../utils/adminBaseUrl';
 */

function resolveAdminBaseUrl() {
	if (process.env.REACT_APP_ADMIN_URL) {
		return process.env.REACT_APP_ADMIN_URL;
	}

	if (typeof window !== 'undefined' && window.location) {
		const host = window.location.hostname;

		if (host === 'dev.gestdoc.cl' || host.startsWith('dev.')) {
			return 'https://devadmin.gestdoc.cl';
		}
		if (host.endsWith('gestdoc.cl')) {
			return 'https://admin.gestdoc.cl';
		}
	}

	return 'http://localhost:4000';
}

const ADMIN_BASE_URL = resolveAdminBaseUrl();

export default ADMIN_BASE_URL;
